export const filterSoundProcessorsSummary = (data) => {
  // keep only 2 recent SP
  let soundProcessorCount = 0;
  const filteredData = data.filter((item) => {
    if (item.device.type === 'Sound Processor') {
      soundProcessorCount += 1;
      return soundProcessorCount <= 2;
    }
    return true;
  });

  filteredData.sort((a, b) =>
    a.device.type.localeCompare(b.device.type),
  );

  return filteredData;
};

export const filterUnknownDataSummary = (data) => {
  // keep only Implant or SP if ear side is unknown
  const filteredData = data.filter(
    (item) =>
      item.device.type === 'Sound Processor' ||
      item.device.type === 'Implant',
  );
  return filterSoundProcessorsSummary(filteredData);
};

export const resetPreviousExpandedSections = () => {
  Array.from(
    document.getElementsByClassName('ccl__icon--rotate--90'),
  ).forEach((element) => element.click());
};

export const filterSoundProcessor = (
  equipmentData,
  setEquipmentData,
) => {
  resetPreviousExpandedSections();
  const filteredData = equipmentData.filter(
    (item) => item.device.type === 'Sound Processor',
  );
  setEquipmentData(filteredData);
  return filteredData;
};

export const filterImplants = (equipmentData, setEquipmentData) => {
  resetPreviousExpandedSections();
  const filteredData = equipmentData.filter(
    (item) => item.device.type === 'Implant',
  );
  setEquipmentData(filteredData);
  return filteredData;
};

export const filterAccessories = (
  equipmentData,
  setEquipmentData,
) => {
  resetPreviousExpandedSections();
  const filteredData = equipmentData.filter(
    (item) =>
      item.device.type === 'Accessory' ||
      item.device.type === 'Actuator Unit' ||
      item.device.type === 'Remote Assistant',
  );
  setEquipmentData(filteredData);
  return filteredData;
};
